const type = 'SET_SERVICE_HISTORY';

const setServiceHistory = (data) => ({
  data,
  type,
});

export { type };
export default setServiceHistory;
